@import '../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../settings-page.module.less';

.table-overflow-container {
  overflow: auto;
}

.table-min-width-container {
  min-width: 720px;
}

.sender-emails-table {
  border-radius: 4px;
  border: @settings-page--table--border;
  background-color: @settings-page--table--body--cell--background-color;
  color: @settings-page--table--body--cell--text-color;
}

.sender-emails-table-header-row {
  background-color: @settings-page--table--header--cell--background-color;
  color: @settings-page--table--header--cell--text-color;
  border-bottom: @settings-page--table--border;
}

.sender-emails-table-body-row {
  border-color: @settings-page--table--border-color;
}
